module.exports = __webpack_public_path__ + "img/accueil-background-sd.ae69fb27.png";